import styled from "styled-components"
import { LayoutContainer } from "./grid"
import { desktopTextStyles } from "./typography.styles"
import Breakpoints from "./breakpoints"
import SmartLink from "./smart-link"

export const FooterWrapper = styled.div`
  padding: 48px 0;
  background: var(--tricorn-black);

  & > ${LayoutContainer} {
    grid-template-rows: auto auto auto auto auto;
  }

  @media (min-width: ${Breakpoints.lg}) {
    padding: 78px 0;
    & > ${LayoutContainer} {
      grid-template-rows: auto auto auto 15px;
    }
  }
`

export const MappedinInfo = styled.div`
  grid-row: 4;
  grid-column: 4 / 10;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 48px;
    grid-column: 2 / 5;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 0px;
    grid-column: 2 / 4;
    grid-row: span 2;
  }
`
export const ImageContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  & > img {
    max-width: 170px;
    color: var(--white);
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-column-end: span 2;
    justify-content: flex-start;
  }
`

export const Address = styled.p`
  ${desktopTextStyles.FooterBodyText}
  color: var(--dark-mode-body-grey);
  line-height: 170%;
  display: flex;
  flex-direction: column;
  margin-top: 22px;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    grid-column-end: span 3;
    margin-top: 23px;
    text-align: left;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column-end: span 2;
    margin-top: 32px;
  }
`
export const SocialIconsContainer = styled.div`
  display: flex;
  & > a:not(:last-child) {
    margin-right: 12px;
  }
  margin-top: 19px;
  justify-content: center;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 24px;
    justify-content: flex-start;
  }
`
export const Copyright = styled.p`
  ${desktopTextStyles.FooterBodyTextSmall}
  color: var(--dark-mode-body-grey);
  margin-top: 48px;
  text-align: center;
  grid-row: 5;
  grid-column: 1 / 13;

  .termsBr,
  .accessibilityBr {
    display: none;
  }

  & > a {
    &,
    :visited,
    :link,
    :active {
      color: var(--dark-mode-body-grey);
    }
  }

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 24px;
    text-align: left;
    white-space: pre-wrap;
    grid-column: 2 / 5;

    .termsBr,
    .accessibilityBr {
      display: initial;
    }
    .divider {
      display: none;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-row: 3;
    margin-top: 60px;
    grid-column: 2 / 4;
    .accessibilityBr {
      display: none;
    }
    .divider:not(:last-of-type) {
      display: initial;
    }
  }

  @media (min-width: ${Breakpoints.xl}) {
  }
`
export const DividingLine = styled.div`
  display: none;

  @media (min-width: ${Breakpoints.md}) {
    display: block;
    background-color: var(--white);
    opacity: 0.25;
    height: 1px;
    grid-row: 3;
    grid-column-start: 2;
    grid-column-end: 12;
    justify-self: center;
    align-self: center;
    width: 100%;
  }

  @media (min-width: ${Breakpoints.lg}) {
    width: 1px;
    grid-row: 1 / 4;
    grid-column: 4;
    justify-self: center;
    align-self: center;
    height: 100%;
  }
`
export const Title = styled.p`
  ${desktopTextStyles.FooterHeadingOne}
  color: var(--dark-mode-body-grey);
  flex-basis: 100%;
  text-align: center;
  grid-column: 3 / 11;
  grid-row: 1;
  margin-bottom: 16px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column-start: 1;
    grid-column-end: 13;
    margin-bottom: 24px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-row: 1;
    grid-column: 5 / 13;
    text-align: left;
    align-items: center;
    margin-top: 15px;
  }
`

export const SiteNavigationContainer = styled.div`
  display: none;

  @media (min-width: ${Breakpoints.md}) {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-row-gap: 32px;
    grid-row-start: 4;
    grid-row: span 4;
    grid-column: 6 / 13;

    margin-top: 70px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-row: 3;
    grid-column: 5 / 12;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 48px;
    grid-row-gap: 24px;
    margin-top: 0px;
  }
`
export const SiteNavListGroup = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.md}) {
  }
  @media (min-width: ${Breakpoints.lg}) {
    flex-basis: auto;
    margin-bottom: 0px;
  }
`

export const IndustriesListGroup = styled(SiteNavListGroup)`
  @media (min-width: ${Breakpoints.md}) {
    grid-column: span 1;
    grid-row: 2 / span 2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: span 2;
  }
`

export const NavListItemGrid = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${Breakpoints.lg}) {
    display: inline-grid;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    grid-template-rows: repeat(4, 1fr);
    grid-column-gap: 32px;
    width: 100%;
  }
`

export const SiteNavGroupTitle = styled.p`
  ${desktopTextStyles.FooterHeadingTwo}
  margin-bottom: 20px;
  color: var(--dark-mode-heading);
`

export const SiteNavItem = styled(SmartLink)`
  ${desktopTextStyles.FooterBodyText} :not(:last-child) {
    margin-bottom: 12px;
  }
  line-height: 120%;
  text-decoration: none;

  :link,
  :active,
  :visited {
    color: var(--dark-mode-body-grey);
  }
`
